import { refresh } from '#components/generics/js/selectors/refresh.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import alert from '#utilities/js/ea/alert.js'
import globals from '#utilities/js/ea/globals.js'
import * as contraints from '#utilities/js/media/constraints.js'
import * as mediastream from '#utilities/js/media/stream.js'
import { setAudioState, audioStates } from './audio.js'
import X from './meet_x.js'
import Xready from './meet_x_ready.js'
import { propsReset, scopeProps, meetProps, setScope, states, setState } from './props.js'
import { display } from './ui.js'
import { validAction } from './valid.js'

const setDial = (name, attendees) => {
  const props = meetProps()
  if (!attendees)
    attendees = []
  props.dial = { name, attendees }
}

const abortStart = () => {
  display('[data-meet="meet_stop"]')
  refresh(null, null)
  globals.ea_link_msg_set(null)
}

const mediaEnabled = async () => {
  try {
    const { window } = defaults
    return await mediastream.get(window, contraints.audioAndVideo)
  } catch (e) {
    console.error(e)
    return false
  }
}

export const start = async (elem, sProps, f) => {
  const {
    msgs,
    ws_url,
    token,
    caller,
    thread_id,
    dial,
    dial_attendees
  } = sProps
  propsReset()
  setState(states.init)
  const props = meetProps()
  props.uri = ws_url
  props.f = f
  props.caller = caller
  props.organizer = caller
  //_props.set(elem, props)
  setScope(sProps)
  const testStream = await mediaEnabled()
  if (!testStream) {
    await alert(msgs.perm_camera)
    abortStart()
  } else {
    /* switch OFF webcam */
    for (const track of testStream.getTracks()) {
      mediastream.stop(track)
    }
    if (dial) {
      setDial(thread_id, dial_attendees)
    }
    Xready() ? await X.init() : await X.init(token)
    // if dial && is_caller -> startDial() && cnx()
  }
}

export const mute = (attendee) => {
  X.mute(attendee)
  setAudioState(audioStates.mute)
}
export const unmute = (attendee) => {
  X.unmute(attendee)
  setAudioState(audioStates.unmute)
}

export const muteall = () => {
  X.muteAll()
}
export const unmuteall = () => {
  X.unmuteAll()
}

export const stream = (mode, param) => {
  X.stream(mode, param)
}

export const screen = (mode) => {
  mode === 'full' ?
    globals.ea_screen_full(true) :
    globals.ea_screen_full(false)
}

export const shareStart = (sharer) => {
  X.uiShareScreen(0, sharer)
}

export const shareStop = (sharer) => {
  X.uiShareScreen(1, sharer)
}

export const delegate = (attendee) => {
  X.delegate(attendee)
}

const callStart = () => {
  typeof X.callStart === 'function' && X.callStart()
}

export const divmeetCancel = (id, from) => {
  const props = meetProps()
  const { dial } = scopeProps()
  let doIt = false
  if (dial) {
    if (from) {
      if (props.atts_cancel.indexOf(from) === -1)
        props.atts_cancel.push(from)
      if (props.atts_cancel.length === scopeProps.dial_attendees.length)
        doIt = true
    }
  } else
    doIt = true
  if (doIt) {
    const button = one('[data-meet="meet_wait"] button')
    button && validAction(button)
  }
}

globals.ea_meet_callstart = callStart
globals.ea_meet_div_cancel = divmeetCancel

